import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
} from "@coreui/react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import {
  getSearchedBookingOrderList,
  getSingleBookingOrder,
} from "../../services/booking.services";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { updateTrip } from "src/services/trip.services";
import { getSearchedUser } from "src/services/user.services";

const schema = z.object({
  // tripVehicleId: z.string().min(1, "Required"),
  //tripTagId: z.string().min(1, "Required"),
  tripAssignedTo: z.string().min(1, "Required"),
  tripRemarks: z.string().optional(),
});

const EditTrip = () => {
  const [tripId, setTripId] = useState("");
  const [tripData, setTripData] = useState(null);
  const [bookingOrderOptions, setBookingOrderOptions] = useState([]);
  const [selectedBookingOrderId, setSelectedBookingOrderId] = useState(null);
  const [bookingOrderData, setBookingOrderData] = useState({});
  const [bookingOrderArray, setBookingOrderArray] = useState([]);
  const [bookingOrderObjectArray, setBookingOrderObjectArray] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const [routeIdArray, setRouteIdArray] = useState(null);

  const [driverOptions, setDriverOptions] = useState([]);
  const [selectedDriverId, setSelectedDriverId] = useState(null);
  const [driverIdArray, setDriverIdArray] = useState([]);
  const [allDriverData, setAllDriverData] = useState([]);

  const [user, setUser] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();
  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );
  useEffect(() => {
    if (id) {
      getSelectedBookingOrderInfo(id);
    }
  }, [id]);

  useEffect(() => {
    getSearchedUserList("");
  }, []);

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      // tripVehicleId: "",
      tripTagId: "",
      tripAssignedTo: "",
      tripRemarks: "",
    },
    resolver: zodResolver(schema),
  });

  const onSubmit = (data) => {
    toast
      .promise(
        updateTrip(data, selectedId),
        {
          loading: "Loading",
          success: "Trip assigned Succesfully",
          error: (err) => {
            return err.response &&
              err.response.data &&
              err.response.data.message
              ? err.response.data.message
              : defaultErrorMessage;
          },
        },
        {
          id: "assign-trip",
        }
      )
      .then(async (response) => {
        getSelectedBookingOrderInfo(selectedId);
      })
      .catch((error) => console.error(error));
  };

  const onError = (err) => {
    console.error(err);
  };

  const getSelectedBookingOrderInfo = (id) => {
    getSingleBookingOrder(id)
      .then((response) => {
        const fetchedBookingOrderData = response.data;
        setBookingOrderData(fetchedBookingOrderData);
        setSelectedBookingOrderId({
          label: fetchedBookingOrderData.bookingOrderId,
          value: fetchedBookingOrderData._id,
        });
        setSelectedRouteId({
          label: fetchedBookingOrderData?.tripRoute?.name,
          value: fetchedBookingOrderData?.tripRoute?._id,
        });
        setSelectedDriverId({
          label:
            fetchedBookingOrderData?.tripAssignedTo?.firstName +
            " " +
            fetchedBookingOrderData?.tripAssignedTo?.lastName +
            "-" +
            fetchedBookingOrderData?.tripAssignedTo?.employeeCode,
          value: fetchedBookingOrderData?.tripAssignedTo?._id,
        });
        setValue("tripTagId", fetchedBookingOrderData.tripTagId);
        // setValue("tripVehicleId", fetchedBookingOrderData.tripVehicleId);
        setValue(
          "tripRemarks",
          fetchedBookingOrderData.tripRemarks
            ? fetchedBookingOrderData.tripRemarks
            : ""
        );
        setValue("tripAssignedTo", fetchedBookingOrderData?.tripAssignedTo._id);
        setSelectedId(fetchedBookingOrderData._id);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleChangeDriver = (selectedOption) => {
    if (selectedOption) {
      setSelectedDriverId(selectedOption);
      setValue("tripAssignedTo", selectedOption.value);
      const driver = allDriverData.find((x) => x._id === selectedOption.value);
      if (driver && driver.tagId) {
        setValue("tripTagId", driver.tagId);
      }
    } else {
      setSelectedDriverId("");
      setValue("tripRtripAssignedTooute", "");
    }
  };

  const handleOnInputChangeDriver = (selectedOption) => {
    const expectedData = driverIdArray.find((a) => a.includes(selectedOption));
    if (!expectedData) {
      getSearchedUserList(selectedOption);
    }
  };

  const getSearchedUserList = (value) => {
    const params = {
      limit: 10,
      page: 1,
      type: "driver",
      name: value,
    };

    getSearchedUser(params)
      .then(async (response) => {
        const fetchedDriverData = response.data;
        setAllDriverData(fetchedDriverData);
        let options = [];
        let driverIdArray = [];

        fetchedDriverData.forEach((element) => {
          const option = {
            value: `${element._id}`,
            label: `${
              element.firstName +
              " " +
              element.lastName +
              "-" +
              element.employeeCode
            }`,
          };
          options.push(option);
          driverIdArray.push(element._id);
        });
        setDriverIdArray(driverIdArray);
        setDriverOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CRow>
          <CCol sm={5}>
            <h4 id="traffic" className="card-title mb-0">
              Update Trip
            </h4>
            {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
          </CCol>
          <CCol sm={7} className="d-none d-md-block"></CCol>
        </CRow>
        <hr />
        <br />
        <CForm onSubmit={handleSubmit(onSubmit, onError)}>
          <CRow>
            <CCol sm={6}>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="bookingOrderId"
                  className="col-sm-3 col-form-label"
                >
                  Booking Order ID:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    disabled
                    value={selectedBookingOrderId}
                    // onChange={handleChangeBookingOrder}
                    // onInputChange={handleOnInputChangeBookingOrder}
                    options={bookingOrderOptions}
                    isClearable={true}
                    isDisabled={id}
                  />
                  {errors.bookingOrderId?.message && (
                    <p className="error_text">
                      {errors.bookingOrderId?.message}
                    </p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="orderNumber"
                  className="col-sm-3 col-form-label"
                >
                  From Location:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="text"
                    id="fromLocation"
                    value={bookingOrderData?.fromLocation?.name}
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="orderNumber"
                  className="col-sm-3 col-form-label"
                >
                  To Location:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="text"
                    id="toLocation"
                    value={bookingOrderData?.toLocation?.name}
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="toNumber"
                  className="col-sm-3 col-form-label"
                >
                  Transfer Order No.:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="text"
                    id="toNumber"
                    value={bookingOrderData?.transferOrderNo}
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="sealNumber"
                  className="col-sm-3 col-form-label"
                >
                  Seal/Bag No:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="text"
                    id="sealNumber"
                    value={bookingOrderData?.sealBag?.serialNo}
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="pickupDate"
                  className="col-sm-3 col-form-label"
                >
                  Pick-up Date:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="date"
                    id="pickupDate"
                    value={bookingOrderData?.pickupDate}
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="pickupTime"
                  className="col-sm-3 col-form-label"
                >
                  Pick-up Time:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="time"
                    id="pickupTime"
                    value={bookingOrderData?.pickupTime}
                  />
                </CCol>
              </CRow>
            </CCol>

            <CCol sm={6} className="d-none d-md-block">
              <CRow className="mb-3">
                <CFormLabel htmlFor="trip" className="col-sm-3 col-form-label">
                  Route Name:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    value={selectedRouteId}
                    options={routeOptions}
                    isClearable={true}
                    isDisabled={true}
                  />
                  {errors.tripRoute?.message && (
                    <p className="error_text">{errors.tripRoute?.message}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="tripStartTime"
                  className="col-sm-3 col-form-label"
                >
                  Start Time:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="time"
                    id="tripStartTime"
                    value={bookingOrderData?.tripStartTime}
                    // {...register("tripStartTime")}
                  />
                  {errors.tripStartTime?.message && (
                    <p className="error_text">
                      {errors.tripStartTime?.message}
                    </p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="tripAssignedBy"
                  className="col-sm-3 col-form-label"
                >
                  CVIT Officer:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    disabled
                    type="text"
                    id="tripAssignedBy"
                    value={
                      bookingOrderData?.tripAssignedBy?.firstName +
                      " " +
                      bookingOrderData?.tripAssignedBy?.lastName
                    }
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="tripAssignedTo"
                  className="col-sm-3 col-form-label"
                >
                  Driver:
                </CFormLabel>
                <CCol sm={8}>
                  <Select
                    onInputChange={handleOnInputChangeDriver}
                    value={selectedDriverId}
                    onChange={handleChangeDriver}
                    options={driverOptions}
                    isClearable={true}
                  />
                  {errors.tripAssignedTo?.message && (
                    <p className="error_text">
                      {errors.tripAssignedTo?.message}
                    </p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                {/* <CFormLabel
                  htmlFor="tripVehicleId"
                  className="col-sm-3 col-form-label"
                >
                  Vehicle ID:
                </CFormLabel> */}
                <CFormLabel
                  htmlFor="tripTagId"
                  className="col-sm-3 col-form-label"
                >
                  Tag ID:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormInput
                    type="text"
                    id="tripTagId"
                    {...register("tripTagId")}
                  />
                  {errors.tripTagId?.message && (
                    <p className="error_text">
                      {errors.tripTagId?.message}
                    </p>
                  )}
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CFormLabel
                  htmlFor="tripRemarks"
                  className="col-sm-3 col-form-label"
                >
                  Remarks:
                </CFormLabel>
                <CCol sm={8}>
                  <CFormTextarea
                    id="tripRemarks"
                    maxLength={100}
                    rows={3}
                    {...register("tripRemarks")}
                    // text="Must be 8-20 words long."
                    text="Must be less than 100 characters."
                  ></CFormTextarea>
                  {errors.tripRemarks?.message && (
                    <p className="error_text">{errors.tripRemarks?.message}</p>
                  )}
                </CCol>
              </CRow>
            </CCol>

            <CRow className="mt-5">
              <div className="d-flex justify-content-end">
                <CButton type="submit" color="primary" className="px-5 py-2">
                  Assign Trip
                </CButton>
              </div>
            </CRow>
          </CRow>
        </CForm>
      </CCardBody>
    </CCard>
  );
};

export default EditTrip;
